export default "__VITE_ASSET__DSPqEOXq__"